import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Gallery from "@/components/site/Gallery";
import Exhibition from "@/components/site/Exhibition";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AmbientAudio from "@/components/site/AmbientAudio";

const Portfolio = () => {
  return (
    <div className="relative text-[#f5f2eb] min-h-screen">
      <div className="poster-bg" />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <Gallery />
          <Exhibition />
          <About />
          <Contact />
        </main>
        <Footer />
      </div>
      <AmbientAudio />
    </div>
  );
};

export default Portfolio;
